<script>
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';

  const dispatch = createEventDispatcher();
  export let title = 'Modal';
  export let isVisible = true;
  export let canSubmit = true;
  export let type = 'confirm';
  let screenHeight = screen.availHeight;
  const onDismissSkrim = (e) => {
    console.log(e);
  }
  
  const onDismiss = () => {
    dispatch('dismiss');
  }

  const onConfirm = () => {
    dispatch('confirm')
    onDismiss()
  }

  export let actions = [
    {
      label: 'Cancel',
      role: 'dismiss',
      handler: onDismiss,
      cssClass: ['btn']
    },
    {
      label: 'Confirm',
      role: 'confirm',
      handler: onConfirm,
      cssClass: ['btn-secondary']
    }
  ];
</script>

<style>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
  }

  .modal > .skrim {
    width: 100%;
    height: 100%;
    background-color: var(--dark-alpha-8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .modal > .skrim > .modal-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--panel);
    color: var(--panel-text);
    padding: 1vw;
    border-radius: var(--modal-border-radius);
  }

  .modal > .skrim > .modal-container > .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: x-large;
  }

  .modal > .skrim > .modal-container > .modal-header > * {
    padding: 1vw;
  }

  .modal > .skrim > .modal-container > .modal-header > .modal-dismiss > i {
    cursor: pointer;
  }

  .modal > .skrim > .modal-container > .modal-content {
    min-width: 600px;
    max-width: 696px;
    min-height: 450px;
    max-height: 522px;
  }

  .modal > .skrim > .modal-container > .modal-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }

  .modal > .skrim > .modal-container > .modal-actions > button:not(:last-child) {
    margin-right: 1vw;
  }

  /* Small devices (landscape phones, 767px and down) */
  @media (max-width: 767px) {
    .row {
      flex-direction: column;
    }

    .modal > .skrim > .modal-container {
      /* width: 380px; */
      width: 94%;
    }

    .modal > .skrim > .modal-container > .modal-content {
      min-width: auto;
      width: 100%;
      padding: 0 2vw;
    }

    .modal > .skrim > .modal-container > .modal-actions {
      justify-content: center;
      padding-left: 1vw;
      padding-right: 1vw;
    }

    .modal > .skrim > .modal-container > .modal-actions > button {
      flex: 1;
    }

    .modal > .skrim > .modal-container > .modal-actions > button:first-child {
      margin-right: 2vw;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
  }
</style>

{#if isVisible}
<main class="modal">
  <div
    class="skrim"
    on:click={onDismissSkrim}>
    <div
      class="modal-container"
      transition:fly="{{ y: 100, duration: 300 }}">
      <header class="modal-header">
        <div class="modal-title">{title}</div>
        <div class="modal-dismiss">
          <i
            class="fas fa-times"
            on:click={onDismiss}></i>
        </div>
      </header>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="modal-actions">
        {#each actions as action, i}
        <button
          class={action.cssClass.join(' ')}
          on:click={action.handler}
          disabled={type !== 'alert' && i === actions.length - 1 ? !canSubmit : false}>{action.label}</button>
        {/each}
      </div>
    </div>
  </div>
</main>
{/if}
